module.exports = __webpack_public_path__ + "img/59701club-baloncesto-gran-canaria.582c5d73.jpg";